import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { StatusItem } from "@ServerTypes/status/status.schema";

type EstimateStatusMap = Record<string, StatusItem>;

const initialEstimateStatusesState: EstimateStatusMap = {};

const estimateStatusesSlice = createSlice({
  name: "estimateStatuses",
  initialState: initialEstimateStatusesState,
  reducers: {
    setEstimatesStatusesData: (_state: EstimateStatusMap, action: PayloadAction<StatusItem[]>) =>
      action.payload.reduce(
        (prev: EstimateStatusMap, curr: StatusItem) => ({ ...prev, [curr.id ?? curr._id ?? ""]: curr }),
        {},
      ),
  },
});

export const { setEstimatesStatusesData } = estimateStatusesSlice.actions;

export const estimateStatuses = estimateStatusesSlice.reducer;

export default estimateStatusesSlice.reducer;
